import './js/helper';
import './js/filter';
import './js/app.min.js';
import './js/tailwind/burger.js';
import './js/tailwind/nav-link.js';
import './js/tailwind/page-load.js';

import './css/tailwind.css';
import './js/src/modules.js';
import './js/src/sliders.js';
import './js/src/accordion.js';

// SECTIONS

import './js/sections/category-search.js';

const sections = {
  header: () => import('./js/sections/header.js'),
  topbar: () => import('./js/sections/topbar.js'),
  hero: () => import('./js/sections/hero.js'),
  heroSlider: () => import('./js/sections/hero-slider.js'),
  contactUsForm: () => import('./js/sections/contact-us-form.js'),
  subscribeForm: () => import('./js/sections/subscribe-form.js'),
  price: () => import('./js/sections/price.js'),
  partnersSwiper: () => import('./js/sections/partners-swiper.js'),
  appointment: () => import('./js/sections/appointment/main.js'),
  findService: () => import('./js/sections/find-service.js'),
  imageGallery: () => import('./js/sections/image-gallery.js'),
};

async function loadSections() {
  const elements = document.querySelectorAll('[data-js-section]');

  const initedSections = [];

  for (const el of elements) {
    const sectionName = el.getAttribute('data-js-section');
    if (sections[sectionName] && !initedSections.includes(sectionName)) {
      try {
        const module = await sections[sectionName]();
        if (module.default) {
          module.default(el);
        }
        initedSections.push(sectionName);
      } catch (err) {
        console.error(`Failed to load section: ${sectionName}`, err);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  global.modules.init();
  loadSections();
});
